import { Explanation } from '@cancercentrum/rcc-react';
import { getDisplayName } from '../utils.ts';
import type { Utskicksprojekt } from '../types.ts';

export const ProjectHeader = (props: {
    utskicksprojekt: Utskicksprojekt;
    sparrad: boolean;
}) => {
    const { utskicksprojekt } = props;

    return (
        <div className="d-flex gap-2 align-items-center">
            {!!utskicksprojekt.ipoDescription && <Explanation>{utskicksprojekt.ipoDescription}</Explanation>}
            <div>
                {getDisplayName(utskicksprojekt)}
            </div>
        </div>
    );
};
